import ky from 'ky';

const kyInstance = ky.create({ prefixUrl: process.env.VUE_APP_API_HOST });

const kyWithAuth = kyInstance.extend({
  hooks: {
    beforeRequest: [
      (request) => {
        const jwt = window.localStorage.getItem('jwt');
        if (jwt) {
          request.headers.set('Authorization', `Bearer ${jwt}`);
        }
      }
    ]
  }
});

export { kyInstance as default, kyWithAuth };
